import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/Login.vue'
import Home from '../views/Home.vue'
import Welcome from '../views/Welcome.vue'
import UserRole from '../views/user/UserRole.vue'
import Authority from '../views/user/Authority.vue'
import Users from '../views/user/Users.vue'
import MemberInfo from '../views/member/MemberInfo.vue'
import ClassRecord from '../views/member/ClassRecord.vue'
import MemberPremoney from '../views/member/MemberPremoney.vue'
import MapLockDevice from '../views/device/MapLockDevice.vue'
import LockDevice from '../views/device/LockDevice.vue'
import ElectronicFence from '../views/device/MapElectronicFence.vue'
import Distributor from '../views/distributor/Distributor.vue'
import Trip from '../views/trip/Trip.vue'
import SimInfo from '../views/sim/SimInfo.vue'
import MyInfo from '../views/my/MyInfo.vue'
import DataDict from '../views/system/DataDict.vue'
import SplitTest from '../views/distributor/SplitTest.vue'
import SplitRuleManage from '../views/distributor/SplitRuleManage.vue'
import SplitRuleDetailManage from '../views/distributor/SplitRuleDetailManage.vue'
import SplitRecordManage from '../views/distributor/SplitRecordManage.vue'
import SplitDetailManage from '../views/distributor/SplitDetailManage.vue'
import InsuranceSplitOrderManage from '../views/member/InsuranceSplitOrderManage.vue'
import InsuranceSplitDetailManage from '../views/member/InsuranceSplitDetailManage.vue'
import OrderSplitConfigManage from '../views/distributor/OrderSplitConfigManage.vue'
import MerchantPaymentConfigManage from '../views/distributor/MerchantPaymentConfigManage.vue'
import SpPaymentConfigManage from '../views/distributor/SpPaymentConfigManage.vue'
import StaffPermission from '../views/staff/StaffPermission.vue'
import Staff from '../views/staff/StaffManage.vue'
import MenuPermission from '../views/permission/MenuPermission.vue'
import ButtonPermission from '../views/permission/ButtonPermission.vue'
import RoleManage from '../views/permission/RoleManage.vue'
import Disclaimer from '../views/system/Disclaimer.vue'
import MyDistributorSetting from '../views/distributor/MyDistributorSetting.vue'
import RepairManage from '../views/repair/RepairManage.vue'
import ProcessedRepairManage from '../views/repair/ProcessedRepairManage.vue'
import DeviceTypeConfig from '../views/device/DeviceTypeConfig.vue'
import UnpaidOrder from '../views/member/UnpaidOrder.vue'
import PaidOrder from '../views/member/PaidOrder.vue'
import CacheManage from '../views/system/CacheManage.vue'
import SplitAccountDetail from '../views/member/SplitAccountDetail.vue'
import OperationRecord from '../views/operation/OperationRecord.vue'
import RefundFailRecord from '../views/member/RefundFailRecord.vue'
import SubMerchantRegister from '../views/distributor/SubMerchantRegister.vue'
import DistributorOrderRank from '../views/trip/DistributorOrderRank.vue'
import InsuranceOrderManage from '../views/member/InsuranceOrderManage.vue'


Vue.use(VueRouter)

const routes = [{
		path: '/',
		redirect: '/login',
	},
	{
		path: '/login',
		component: Login,
		meta: { title: '登录' }
	},
	{
		path: '/sub-merchant/register',
		component: SubMerchantRegister,
		meta: { title: '特约商户入驻' }
	},
	{
		path: '/home',
		component: Home,
		redirect: 'welcome',
		children: [
			{
				path: '/welcome',
				component: Welcome,
				meta: { title: '首页' }
			},
			{
				path: '/system/role',
				component: UserRole,
				meta: { title: '角色管理' }
			},
			{
				path: '/system/authorities',
				component: Authority,
				meta: { title: '资源管理' }
			},
			{
				path: '/system/user',
				component: Users,
				meta: { title: '用户管理' }
			},
			{
				path: '/memberInfo/list',
				component: MemberInfo,
				meta: { title: '会员信息' }
			},
			{
				path: '/classRecord/findAllRecord',
				component: ClassRecord,
				meta: { title: '骑行记录' }
			},
			{
				path: '/member/premoney/list',
				component: MemberPremoney,
				meta: { title: '押金管理' }
			},
			{
				path: '/device/getMapLockDevice',
				component: MapLockDevice,
				meta: { title: '地图车锁列表' }
			},
			{
				path: '/device/getLockDevicePageInfo',
				component: LockDevice,
				meta: { title: '设备管理' }
			},
			{
				path: '/electronicFence/ElectronicFenceList',
				component: ElectronicFence,
				meta: { title: '绘制电子围栏' }
			},
			{
				path: '/distributor/list',
				component: Distributor,
				meta: { title: '运营商信息' }
			},
			{
				path: '/trip/list',
				component: Trip,
				meta: { title: '行程列表' }
			},
			{
				path: '/sim/list',
				component: SimInfo,
				meta: { title: 'SIM卡管理' }
			},
			{
				path: '/my/myInfo',
				component: MyInfo,
				meta: { title: '个人信息' }
			},
			{
				path: '/system/dataDict',
				component: DataDict,
				meta: { title: '字典配置' }
			},
			{
				path: '/distributor/splitTest',
				component: SplitTest,
				meta: { title: '分账测试' }
			},
			{
				path: '/distributor/splitRule',
				component: SplitRuleManage,
				meta: { title: '分账规则管理' }
			},
			{
				path: '/distributor/splitRuleDetail',
				component: SplitRuleDetailManage,
				meta: { title: '分账规则明细' }
			},
			{
				path: '/distributor/splitRecord',
				component: SplitRecordManage,
				meta: { title: '分账记录管理' }
			},
			{
				path: '/distributor/splitDetail',
				component: SplitDetailManage,
				meta: { title: '分账明细管理' }
			},
			{
				path: '/distributor/orderSplitConfig',
				component: OrderSplitConfigManage,
				meta: { title: '订单分账配置' }
			},
			{
				path: '/distributor/merchantPaymentConfig',
				component: MerchantPaymentConfigManage,
				meta: { title: '商户支付配置' }
			},
			{
				path: '/distributor/spPaymentConfig',
				component: SpPaymentConfigManage,
				meta: { title: '服务商配置' }
			},
			{
				path: '/staff/staffPermission',
				component: StaffPermission,
				meta: { title: '员工权限' }
			},
			{
				path: '/staff/staffManage',
				component: Staff,
				meta: { title: '员工管理' }
			},
			{
				path: '/permission/menu',
				component: MenuPermission,
				meta: { title: '菜单管理' }
			},
			{
				path: '/permission/button',
				component: ButtonPermission,
				meta: { title: '按钮权限管理' }
			},
			{
				path: '/permission/role',
				component: RoleManage,
				meta: { title: '角色管理' }
			},
			{
				path: '/system/disclaimer',
				component: Disclaimer,
				meta: { title: '免责声明' }
			},
			{
				path: '/distributor/mySetting',
				component: MyDistributorSetting,
				meta: { title: '运营配置' }
			},
			{
				path: '/repair/repairManage',
				component: RepairManage,
				meta: { title: '报修信息' }
			},
			{
				path: '/repair/processedRepairManage',
				component: ProcessedRepairManage,
				meta: { title: '已处理报修' }
			},
			{
				path: '/device/typeConfig',
				component: DeviceTypeConfig,
				meta: { title: '设备类型设置' }
			},
			{
				path: '/member/unpaidOrder',
				component: UnpaidOrder,
				meta: { title: '待支付订单' }
			},
			{
				path: '/member/paidOrder',
				component: PaidOrder,
				meta: { title: '待支付订单(已支付)' }
			},
			{
				path: '/system/cache',
				component: CacheManage,
				meta: { title: '缓存管理' }
			},
			{
				path: '/member/splitAccountDetail',
				component: SplitAccountDetail,
				meta: { title: '分账明细' }
			},
			{
				path: '/operation/record',
				component: OperationRecord,
				meta: { title: '运维记录' }
			},
			{
				path: '/member/refundFailRecord',
				component: RefundFailRecord,
				meta: { title: '退款失败记录' }
			},
			{
				path: '/member/insuranceSplitOrderManage',
				component: InsuranceSplitOrderManage,
				meta: { title: '分账订单' }
			},
			{
				path: '/member/insuranceSplitDetailManage',
				component: InsuranceSplitDetailManage,
				meta: { title: '分账订单明细' }
			},
			{
				path: '/trip/distributorOrderRank',
				component: DistributorOrderRank,
				meta: { title: '运营商订单排行' }
			},
			{
				path: '/member/insuranceOrderManage',
				component: InsuranceOrderManage,
				meta: { title: '骑行险订单管理' }
			},
		],
	},
]

const router = new VueRouter({
	mode: 'hash',
	routes,
})

router.beforeEach((to, from, next) => {
	if (to.path === '/login' || to.path === '/sub-merchant/register') return next()
	const tokenStr = window.sessionStorage.getItem('token')
	if (!tokenStr) return next('/login')
	next()
})

export default router
